<div class="wrapper">
  <div class="login large-border-radius d-flex flex-column">
    <section class="form-section flex-grow-1 d-flex justify-content-center">
      <div class="form-wrapper d-flex flex-column align-items-center">
        <div class="logo"></div>
        <div class="form w-100">

          <router-outlet />

        </div>
      </div>
    </section>
    <footer class="d-flex justify-content-center p-6 hide-on-mobile">
      <lbt-text color="black-6">© {{ year }} LBOARD</lbt-text>
    </footer>
  </div>
</div>